import axios from 'axios';
import config from '../Config/config';

export default class CareerRepository {
  constructor() {
    this.careerAxios = axios.create({
      baseURL: config.urls.careerPortalApi,
    });
  }

  getJobDetails = (id) => {
    return this.careerAxios.get(`api/job/${id}`);
  }
}